import React from 'react'
import PropTypes from 'prop-types'
import { useSmartTranslation } from '../../../../../../generic/hooks/useSmartTranslation'
import { SmartSelect } from '../../../../../../generic/smartSelect'
import { NO_COMPONENT } from '../../utils/componentFilter'

/**
 * Story 219 (CA1): the "Component" field, the same in the widget's header and in the "Show all"
 * modal. Its value is the component's CODE; the option objects stay inside, so the caller never
 * reads a code back out of the visible text (RN5).
 *
 * @param {Object} props
 * @param {string} props.value - The chosen code, or NO_COMPONENT
 * @param {{code: string, label: string}[]} props.options
 * @param {Function} props.onChange - (nextCode) => void
 */
// O1 amendment (RN15.2): a chosen code that is not among the options -- no catalog for this surface, or
// a code missing from it -- still shows, as just the code (RN6.1 without a name), so the field is never
// empty while the list is filtered by it and can be cleared. It is NOT added to the drop-down.
const shownValue = (value, options) => {
  if (value === NO_COMPONENT) return NO_COMPONENT
  return options.find((option) => option.code === value) ?? { code: value, label: value }
}

const ComponentSelect = ({ value, options, onChange }) => {
  const { t_ } = useSmartTranslation()

  return (
    <SmartSelect
      width='12rem'
      label={t_('Component')}
      value={shownValue(value, options)}
      selectableOptions={options}
      autoSelectFirst={false}
      onChange={(option) => { onChange(option?.code ?? NO_COMPONENT) }}
      disableClearable={false}
    />
  )
}

ComponentSelect.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({ code: PropTypes.string, label: PropTypes.string })).isRequired,
  onChange: PropTypes.func.isRequired
}

export default ComponentSelect
